import React from "react";
import {Button, Form, message, Select} from "antd";
import "./CodPaymentMethodSelectionForm.css";
import {useCodPaymentMethodSelection} from "../../../../../hooks/useCodPaymentMethodSelection";
import {useFormik} from "formik";
import * as Yup from "yup";
import {DocumentModal} from "../../../../documents/documentModal";
import {useStore} from "../../../../../hooks/useStore";
import {useCodPaymentBrandLabel} from "../../../../../hooks/useCodPaymentBrandLabel";
import {useHistory} from "react-router-dom";
import {
    FormContainer,
    StyledForm,
    StyledCheckbox,
    ButtonContainer,
    LoadingText,
    ErrorModal
} from "../../../../cashOnDelivery/summary/filterButton/codAggrementBlock/style/CodAggrementSelectionModal.styles";

export const CodPaymentMethodSelectionForm = ({
    paymentMethodsSelectionEnabledSubCompanies = [],
    recallState,
    recallFn = () => {}
}) => {
    const stores = useStore();
    const codPaymentBrandLabel = useCodPaymentBrandLabel();
    const history = useHistory();
    const {
        canCodPaymentMethodSelectionSubcompanies,
        contractLoading,
        showContractsMissingFieldsModal,
        contractsMissingFields,
        resetContractsMissingFields,
        generateCoDPaymentContract
    } = useCodPaymentMethodSelection({
        initialCall: paymentMethodsSelectionEnabledSubCompanies?.length === 0,
        initialData: paymentMethodsSelectionEnabledSubCompanies,
        dependencies: []
    });

    const formik = useFormik({
        initialValues: {
            subCompanyId: canCodPaymentMethodSelectionSubcompanies?.[0]?._id,
            onlinePaymentMethod: true,
            codPaymentMethod: false,
            mealCardPaymentMethod: false,
            codContractUrl: "",
            showCodContractModal: false,
            codContractSigned: false,
            codContractId: ""
        },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            subCompanyId: Yup.string().required("Şube seçilmedi")
        }),
        onSubmit: async values => {
            if (values.codPaymentMethod && !values.codContractSigned) {
                message.error("Sözleşme onaylanmamış");
                formik.setFieldError("codPaymentMethod", "Sözleşme onaylanmamış");
                return false;
            }

            const payload = {
                subCompanyId: values.subCompanyId,
                onlinePaymentMethod: values.onlinePaymentMethod,
                codPaymentMethod: values.codPaymentMethod,
                mealCardPaymentMethod: values.mealCardPaymentMethod
            };

            const resultOfRequest = await stores.companyStore.updateSubCompanyCodPaymentMethodsSelfSelection(
                payload
            );
            if (resultOfRequest?.success === false) {
                message.error(resultOfRequest?.message);
                return false;
            }

            recallFn();

            return true;
        }
    });

    const onChangeSubCompany = e => {
        formik.setValues({
            ...formik.initialValues,
            subCompanyId: e
        });
    };

    const onChangeCoDPaymentMethod = async e => {
        const isCoDPaymentMethodSelected = Boolean(e?.target?.checked);
        if (!isCoDPaymentMethodSelected) {
            formik.setFieldValue("codPaymentMethod", false);
            return;
        }

        const contract = await generateCoDPaymentContract({
            subCompanyId: formik.values.subCompanyId,
            createNewContract: true
        });

        if (contract?.success === false) {
            message.error(contract?.message);
            return;
        }

        formik.setValues({
            ...formik.values,
            codContractUrl: contract?.contractPath,
            codContractId: contract?.contractId,
            showCodContractModal: true
        });
    };

    const onCodContractApproved = async () => {
        try {
            const contractApproveResult = await stores.contractStore.changeApprovalStatus({
                contractId: formik.values.codContractId,
                isApproved: true
            });
            if (contractApproveResult?.success === false) {
                message.error(contractApproveResult?.message);
                formik.setValues({...formik.values, showCodContractModal: false});
                return false;
            } else {
                formik.setValues({
                    ...formik.values,
                    codPaymentMethod: true,
                    codContractSigned: true,
                    showCodContractModal: false
                });
            }
        } catch (error) {
            message.error("Sözleşme onaylanamadı");
            formik.setValues({...formik.values, showCodContractModal: false});
        }
        formik.setValues({
            ...formik.values,
            codPaymentMethod: true,
            codContractSigned: true,
            showCodContractModal: false
        });
    };

    return (
        <>
            <DocumentModal
                visibility={formik.values.showCodContractModal}
                onCancel={() => formik.setFieldValue("showCodContractModal", false)}
                documentUrl={formik.values.codContractUrl}
                title="Kapıda Ödeme Sözleşmesi"
                onApprove={onCodContractApproved}
                isNeedForApproval={true}
                description={
                    <p style={{fontSize: "16px", textAlign: "left", lineHeight: "1.8"}}>
                        Yukarıda yazan hususlarda mutabık kaldığımı kabul eder, sözleşmenin bir
                        kopyasını bir hafta içerisinde ıslak imzalı olarak Vigo Merkez Ofise
                        göndereceğimi teyit ederim.
                    </p>
                }
            />

            <FormContainer>
                <StyledForm layout="horizontal">
                    <div className="form-title">Ödeme Yöntemi Seçim Formu</div>

                    <div className="section-title">Ödeme Yöntemi Seçiniz</div>

                    <Form.Item name="paymentMethod">
                        <StyledCheckbox
                            checked={formik.values.onlinePaymentMethod}
                            disabled={contractLoading}
                        >
                            Sadece Online
                        </StyledCheckbox>
                    </Form.Item>

                    <Form.Item name="paymentMethod">
                        <StyledCheckbox
                            checked={formik.values.codPaymentMethod}
                            onChange={onChangeCoDPaymentMethod}
                            disabled={contractLoading}
                        >
                            {contractLoading ? (
                                <LoadingText>Sözleşme Oluşturuluyor...</LoadingText>
                            ) : (
                                ""
                            )}
                            Kapıda Ödeme (Kredi Kartı veya Nakit)
                        </StyledCheckbox>
                    </Form.Item>

                    <Form.Item name="paymentMethod">
                        <StyledCheckbox
                            checked={formik.values.mealCardPaymentMethod}
                            disabled={true}
                        >
                            Yemek Kartı (Online/Kapıda) - Yakında Gelecek
                        </StyledCheckbox>
                    </Form.Item>

                    <div className="info-text">
                        {codPaymentBrandLabel} ile Vigo kuryelerinin sizin adınıza kapıda ödeme
                        alabilmesi için,
                        <b>Kapıda Ödeme (Kredi Kartı veya Nakit)</b> seçeneğini seçmeli ve çıkan{" "}
                        <b>dijital sözleşmeyi</b> okuyup onaylamalısınız.
                    </div>

                    <Form.Item>
                        <ButtonContainer>
                            <Button
                                type="primary"
                                size="large"
                                htmlType="submit"
                                onClick={formik.handleSubmit}
                                loading={formik.isSubmitting}
                                disabled={contractLoading}
                            >
                                {contractLoading ? "Sözleşme Oluşturuluyor..." : "Seçimi Onayla"}
                            </Button>
                            <Button
                                size="large"
                                htmlType="submit"
                                onClick={() => history.push("/musteri/hesabim")}
                                disabled={contractLoading}
                            >
                                Hesap Bilgilerini Düzenle
                            </Button>
                        </ButtonContainer>
                    </Form.Item>
                </StyledForm>
            </FormContainer>

            <ErrorModal
                visible={showContractsMissingFieldsModal}
                title="Sözleşme Oluşturulamadı"
                onCancel={resetContractsMissingFields}
                cancelText="İptal"
                okText="Hesap Bilgilerini Düzenle"
                onOk={() => {
                    window.open("/musteri/hesabim", "_blank");
                }}
            >
                <p>
                    Lütfen hesap bilgilerinizi düzenleyiniz.
                    <br />
                    Eksik alanlar:{" "}
                    <ul>
                        {contractsMissingFields?.map(field => (
                            <li key={field}>{field}</li>
                        ))}
                    </ul>
                </p>
            </ErrorModal>
        </>
    );
};
